export const contentTableConfig = {
  propList: [
    { prop: 'usedBy', label: '使用人', minWidth: '80'},
    { prop: 'usedByDept', label: '使用人部门', minWidth: '80'},
    { prop: 'extProfile', label: '号码注册人', minWidth: '80'},
    { prop: 'userid', label: 'userid', minWidth: '100'},
    { prop: 'enterpriseWechatDeptName', label: '企业微信部门', minWidth: '100' },
    { prop: 'corpName', label: '主体', minWidth: '120' },
    { prop: 'status', label: '状态', minWidth: '80' },
    { prop: 'deletedAt', label: '退出时间', minWidth: '100', sortable: 'custom' },
    { prop: 'memberName', label: '成员名称', minWidth: '100' },
    { prop: 'alias', label: '别名', minWidth: '100' },
    { label: '操作', minWidth: '80', slotName: 'handler', fixed: 'right'}
  ]
}
